export const props = Object.freeze({
  /**
   * Name of the selected system color, e.g. `primary`. Empty or an unknown name selects the
   * none swatch. A status color (`success`, `warning`, `danger`, `info`) is a system color the
   * picker does not offer, so it marks no swatch at all.
   *
   * @type {String}
   * @default undefined
   */
  value: {
    type: String,
    default: undefined,
  },
  /**
   * URL of a stylesheet declaring the site's custom properties on `:root` (the `/ui/tokens.css` endpoint).
   * The swatches preview those values; without it they show the surrounding document's colors.
   *
   * @type {String}
   * @default undefined
   */
  themeStylesheetUrl: {
    type: String,
    default: undefined,
  },
});
